var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBurgerIconOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "burger-menu responsive--menu--icon pointer",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "top",
    fill: "#000",
    d: "M0 9h30v2H0z",
    style: {
      transformOrigin: "0px 0px"
    },
    transform: "matrix(1,0,0,1,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mid",
    fill: "#000",
    d: "M0 14h30v2H0z",
    style: {
      transformOrigin: "0px 0px",
      opacity: 1,
      fill: "rgb(0, 0, 0)"
    },
    transform: "matrix(1,0,0,1,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bot",
    fill: "#000",
    d: "M0 19h30v2H0z",
    style: {
      transformOrigin: "0px 0px"
    },
    transform: "matrix(1,0,0,1,0,0)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerIconOpen);
export default __webpack_public_path__ + "static/media/burgerIconOpen.2cd00511a04aa04edd3ed37ae94cab78.svg";
export { ForwardRef as ReactComponent };